import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ForecastPaginated } from 'src/features/forecastPaginated/ForecastPaginated';
import { PageLayout } from 'src/layouts/PageLayout';

export function ForecastDefaultPage(): ReactElement {
  const { t } = useTranslation('forecast');

  return (
    <PageLayout title={t('Forecast')}>
      <ForecastPaginated />
    </PageLayout>
  );
}
